import { markBars, markViewBox } from '@/components/brand/brandPaths'

/** The mark with "United". Decorative: give the surrounding link or element its accessible name. */
export const Lockup = () => (
  <svg className="lockup" viewBox="0 0 202 60.72" aria-hidden="true">
    <use href="#ua-lockup" />
  </svg>
)

/** The three-bar mark, coloured by `--b1`/`--b2`/`--b3` or the current colour. */
export const Mark = () => (
  <svg viewBox="0 0 47.5 60.72" aria-hidden="true">
    <use href="#ua-mark" />
  </svg>
)

/**
 * The mark as a working part: each bar is its own element so it can animate, building from the
 * base while software works (styled by `.loader` in console.css).
 */
export const WorkingMark = () => (
  <span className="loader" aria-hidden="true">
    <svg viewBox={markViewBox}>
      {markBars.map((bar) => (
        <path key={bar.variable} d={bar.d} />
      ))}
    </svg>
  </span>
)

type IconName = 'arrow' | 'check' | 'person'

export const Icon = ({ name }: { name: IconName }) => (
  <svg className={`i-${name}`} viewBox="0 0 16 16" aria-hidden="true">
    <use href={`#i-${name}`} />
  </svg>
)
